import RadioGroup from './RadioGroup.js';
import Radio from './Radio.js';
import RadioButton from './RadioButton.js'; // Radio.RadioGroup = RadioGroup;//使用Radio.Group代替
// Radio.RadioButton = RadioButton;//使用Radio.Button代替

Radio.Group = RadioGroup;
Radio.Button = RadioButton;
export default Radio;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-radio/src/index.js